export default [
	{
		cnpj: '00873894000124',
		reason: 'A empresa solicitou a exclusão de seus dados da nossa base',
		company: 'Águia Branca',
	},
]
